<script lang="ts">
  import { onMount } from "svelte";
  import Text from "../components/Text.svelte";

  let ref: any;
  let focused: boolean = false;
  let digits: string[] = [];
  let range: Array<any> = new Array(4);
  export let didComplete: (value: string) => void;
  export let error: string | null = null;

  function onChange(e: any) {
    const { value } = e.target;
    digits = value.split("");

    if (digits.length === 4) {
      didComplete(value);
    }
  }

  function focus() {
    ref.focus();
  }

  function didFocus() {
    focused = true;
  }

  function didBlur() {
    focused = false;
  }

  onMount(() => {
    ref.focus();
    focused = true;
  });
</script>

<div class="container" on:click={focus}>
  <input
    bind:this={ref}
    class="hidden-input"
    on:input={onChange}
    on:focus={didFocus}
    on:blur={didBlur}
  />
  <div class="digit-container">
    {#each range as _value, i}
      <div class="input-container" class:margin-left={i !== 0}>
        {#if digits.length === i && focused}
          <span class="blinking-cursor">|</span>
        {/if}
        <div class="digit" class:placeholder={!digits[i]}>
          {digits[i] || "0"}
        </div>
      </div>
    {/each}
  </div>
  {#if error}
    <div class="error">
      <div class="icon-container">
        <img src="static/assets/icons/icon-info.svg" alt="info" width={11} height={11} />
      </div>
      <div class="error-text">
        <Text ocd>{error}</Text>
      </div>
    </div>
  {/if}
</div>

<style>
  .digit-container {
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: row;
    min-height: 76px;
  }

  .input-container {
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    min-height: 112px;
    border-radius: 20px;
  }

  .margin-left {
    margin-left: 5px;
  }

  .hidden-input {
    border: none;
    outline: none;
    padding: 0;
    width: 1;
    height: 1;
    opacity: 0;
    position: absolute;
    z-index: -1;
    pointer-events: none;
  }

  .digit {
    font-size: 32px;
    line-height: 36px;
    letter-spacing: -1px;
  }

  .placeholder {
    color: var(--rekki-transparency-dark);
  }

  .error {
    background-color: var(--rekki-warning);
    margin-top: 8px;
    border-radius: 8px;
    padding: 9px 10px;
    display: flex;
    flex-direction: row;
  }

  .error-text {
    margin-top: 1px;
  }

  .blinking-cursor {
    position: absolute;
    padding-bottom: 4px;
    padding-right: 16px;
    font-weight: 100;
    font-size: 32px;
    color: var(--rekki-neutral-02);
    -webkit-animation: 1s blink step-end infinite;
    -moz-animation: 1s blink step-end infinite;
    -ms-animation: 1s blink step-end infinite;
    -o-animation: 1s blink step-end infinite;
    animation: 1s blink step-end infinite;
  }

  @keyframes blink {
    from,
    to {
      color: transparent;
    }
    50% {
      color: var(--rekki-dark);
    }
  }

  @-moz-keyframes blink {
    from,
    to {
      color: transparent;
    }
    50% {
      color: var(--rekki-dark);
    }
  }

  @-webkit-keyframes blink {
    from,
    to {
      color: transparent;
    }
    50% {
      color: var(--rekki-dark);
    }
  }
</style>
